(function($) {
    var $fn = $("#layout_footer"),
        tablet = window.matchMedia("(max-width: 74.9375em)");

    if ($fn.length) {
        var $slider = $fn.find("[data-partners-slider]");

        function togglePartnersSlider() {
            if (!$slider.length || typeof $.fn.slick !== "function") {
                return;
            }

            if (tablet.matches) {
                if (!$slider.hasClass("slick-initialized")) {
                    $slider.slick({
                        accessibility: false,
                        infinite: true,
                        speed: 500,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        autoplay: true,
                        autoplaySpeed: 5000,
                        arrows: true,
                        prevArrow: "<a class='slick-prev slick-arrow icon--chevron-left'></a>",
                        nextArrow: "<a class='slick-next slick-arrow icon--chevron-right'></a>",
                        pauseOnHover: false,
                        dots: false,
                        swipeToSlide: true,
                        responsive: [
                            {
                                breakpoint: 960,
                                settings: {
                                    slidesToShow: 3
                                }
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 2
                                }
                            }
                        ]
                    });
                }
            } else if ($slider.hasClass("slick-initialized")) {
                $slider.slick("unslick");
            }
        }

        togglePartnersSlider();
        tablet.addEventListener("change", togglePartnersSlider);
    }
})(jQuery);
